import { render } from "./TheAlert.vue?vue&type=template&id=e84ce49c&scoped=true"
import script from "./TheAlert.vue?vue&type=script&lang=js"
export * from "./TheAlert.vue?vue&type=script&lang=js"

import "./TheAlert.vue?vue&type=style&index=0&id=e84ce49c&scoped=true&lang=less"

import exportComponent from "C:\\REPOS\\pos-web-app\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-e84ce49c"]])

export default __exports__